async function n(t,i){let[{relottie:e},{default:o}]=await Promise.all([import('./dist-TF5BXIJN.js'),import('./dist-FIOD4G6J.js')]),s=await e().use(o,{lss:i}).process(JSON.stringify(t));return JSON.parse(s.value)}

export { n as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-NE7LDUDE.js.map